

































































import { Component, Vue } from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { HsabExpenseFormMode, HsabExpenseResponse, TransferSchedule, TransferScheduleStatus } from "@/shared/types";
import HsabExpenseCardRowExpenseDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseDetail.vue";
import HsabExpenseCardRowPayee from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPayee.vue";
import HsabExpenseCardRowExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseEvidence.vue";
import HsabExpenseCardRowInsuranceClaim from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowInsuranceClaim.vue";
import HsabExpenseCardRowSchedule from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowSchedule.vue";
import HsabExpenseCardRowRelationships from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowRelationships.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner,
    HsabExpenseCardRowInsuranceClaim,
    HsabExpenseCardRowExpenseEvidence,
    HsabExpenseCardRowPayee,
    HsabExpenseCardRowExpenseDetail,
    HsabExpenseCardRowSchedule,
    HsabExpenseCardRowRelationships,
  }
})
export default class RecurringExpenseTemplateModal extends Vue {
  themeStore = useThemeStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();

  get showModal () {
    return this.hsabExpenseFormStore.modalMode === HsabExpenseFormMode.recurringTemplate;
  }

  get expense (): HsabExpenseResponse {
    return this.hsabExpenseFormStore.expense;
  }

  get schedule (): TransferSchedule {
    if (this.expense) {
      return this.expense.schedule;
    }
    return null;
  }

  get editButtonTooltip () {
    return "";
  }

  get isScheduleActive () {
    return this.schedule.status === TransferScheduleStatus.Active;
  }

  onModalCloseClicked () {
    this.hsabExpenseFormStore.closeModal();
  }

  isEditable () {
    return this.schedule.status === TransferScheduleStatus.None
        || this.schedule.status === TransferScheduleStatus.Active
        || this.schedule.status === TransferScheduleStatus.Revised;
  }

  onEditClicked () {
    // todo
  }
}
